var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.246,
    height: 14.207,
    viewBox: "0 0 16.246 14.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    transform: "translate(-1351.35 -429.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-forward",
    "data-name": "Icon ionic-ios-arrow-forward",
    d: "M16.921,13.3,11.545,7.925a1.011,1.011,0,0,1,0-1.434,1.024,1.024,0,0,1,1.438,0l6.091,6.087a1.013,1.013,0,0,1,.03,1.4l-6.116,6.129a1.015,1.015,0,1,1-1.438-1.434Z",
    transform: "translate(1340.104 423.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-forward-2",
    "data-name": "Icon ionic-ios-arrow-forward",
    d: "M16.921,13.3,11.545,7.925a1.011,1.011,0,0,1,0-1.434,1.024,1.024,0,0,1,1.438,0l6.091,6.087a1.013,1.013,0,0,1,.03,1.4l-6.116,6.129a1.015,1.015,0,1,1-1.438-1.434Z",
    transform: "translate(1348.227 423.405)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSelected);
export default __webpack_public_path__ + "static/media/Add-Selected.a10a4abf2c5ed1462db329e34fc7a0ca.svg";
export { ForwardRef as ReactComponent };